class Logger {
    log(message){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const letsDebug = urlParams.get('letsDebug')
        if (letsDebug === 'sure'){
            console.log(message);
        }
    }
}

export default new Logger()